var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _g2, _g3, _path26, _g4, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetOrderHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20994_306980)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    className: "illustration_secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M819.6 86.5L737.7 160H591.2L674.8 86.5L576.2 0H723L819.6 86.5Z",
    fill: "black",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M675 86.5L593.1 160H446.6L530.3 86.5L431.6 0H578.4L675 86.5Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M530.4 86.5L448.5 160H302L385.7 86.5L287 0H433.8L530.4 86.5Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M775.7 48.2982C767.6 45.2174 759.6 42.2361 751.7 39.1553C753.5 27.0311 766.3 17.6895 766 5.06836C774.1 8.1491 782.1 11.1305 790 14.2112C788.2 26.2361 775.5 35.6771 775.7 48.2982Z",
    className: "illustration_primary-lightest"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M786.2 20.0745C779.8 17.59 773.3 15.1056 766.8 12.6211C767 12.0248 767.2 11.4285 767.3 10.8323C773.9 13.3167 780.4 15.8012 786.8 18.2857C786.7 18.882 786.5 19.4782 786.2 20.0745Z",
    className: "illustration_primary-ultralight"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M784.2 23.9503C777.9 21.4659 771.5 19.0808 765.2 16.5963C765.5 16 765.8 15.4038 766 14.9069C772.4 17.3913 778.8 19.8758 785.2 22.3603C784.9 22.7578 784.6 23.3541 784.2 23.9503Z",
    className: "illustration_primary-ultralight"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M782.001 27.6273C775.701 25.1429 769.401 22.7578 763.101 20.2733C763.401 19.677 763.801 19.1801 764.101 18.5839C770.401 21.0683 776.701 23.4534 783.001 25.9379C782.701 26.5342 782.301 27.1304 782.001 27.6273Z",
    className: "illustration_primary-ultralight"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M779.7 31.4037C773.4 28.9192 767.1 26.5341 760.9 24.0497C761.2 23.4534 761.6 22.9565 761.9 22.3602C768.2 24.8447 774.5 27.2298 780.7 29.7143C780.4 30.3105 780 30.8074 779.7 31.4037Z",
    className: "illustration_primary-ultralight"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M675.4 99.9752C682.7 104.348 689.8 108.721 696.9 113.093C705.3 104.447 705 88.8447 715 81.4907C707.7 77.118 700.6 72.7454 693.5 68.3727C685.2 77.0186 685.4 92.6211 675.4 99.9752Z",
    className: "illustration_primary-lightest"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M691.2 74.9317C697 78.41 702.8 81.8883 708.7 85.4659C709 84.969 709.4 84.4721 709.8 83.9752C703.9 80.3976 698 76.9193 692.2 73.3417C691.8 73.8386 691.5 74.3355 691.2 74.9317Z",
    className: "illustration_primary-ultralight"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M689.4 78.7081C695.1 82.087 700.9 85.5653 706.6 89.0435C706.9 88.4472 707.2 87.9504 707.5 87.3541C701.7 83.8758 695.9 80.3976 690.2 77.0187C689.9 77.615 689.6 78.1118 689.4 78.7081Z",
    className: "illustration_primary-ultralight"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M687.801 82.7826C693.501 86.1615 699.201 89.5404 704.901 93.0186C705.101 92.4223 705.401 91.8261 705.601 91.2298C699.901 87.8509 694.201 84.3727 688.501 80.9938C688.301 81.59 688.001 82.1863 687.801 82.7826Z",
    className: "illustration_primary-ultralight"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M686.301 86.7578C692.001 90.1367 697.701 93.5156 703.401 96.8945C703.601 96.2982 703.901 95.7019 704.101 95.1056C698.401 91.7268 692.701 88.3479 687.001 84.969C686.701 85.5653 686.501 86.1615 686.301 86.7578Z",
    className: "illustration_primary-ultralight"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20994_306980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 692,
    y: 14,
    width: 156,
    height: 106
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M847.701 14.8075H692.801V119.851H847.701V14.8075Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20994_306980)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M835 167.652L727.6 178.981C726.6 179.081 725.7 178.385 725.6 177.391L716.1 88.0497C716 87.0559 716.7 86.1615 717.7 86.0621L825.1 74.733C826.1 74.6336 827 75.3292 827.1 76.323L836.6 165.665C836.7 166.658 836 167.553 835 167.652Z",
    fill: "#FFE7DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20994_306980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 716,
    y: 74,
    width: 121,
    height: 105
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M835 167.652L727.6 178.981C726.6 179.081 725.7 178.385 725.6 177.391L716.1 88.0497C716 87.0559 716.7 86.1615 717.7 86.0621L825.1 74.733C826.1 74.6336 827 75.3292 827.1 76.323L836.6 165.665C836.7 166.658 836 167.553 835 167.652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20994_306980)"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M833.867 95.3376L833.467 91.5823L713.144 104.244L713.545 108L833.867 95.3376Z",
    fill: "#0730C3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M835.924 115.155L835.523 111.4L715.201 124.062L715.601 127.817L835.924 115.155Z",
    fill: "#0730C3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M734.49 75.9656L729.617 76.4784L742.358 196.053L747.231 195.541L734.49 75.9656Z",
    fill: "#EE0000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M760.09 73.2864L755.218 73.7992L767.959 193.374L772.832 192.861L760.09 73.2864Z",
    fill: "#EE0000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M785.79 70.597L780.917 71.1097L793.658 190.685L798.531 190.172L785.79 70.597Z",
    fill: "#EE0000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M811.39 67.9179L806.518 68.4307L819.259 188.006L824.131 187.493L811.39 67.9179Z",
    fill: "#EE0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20994_306980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 711,
    y: 89,
    width: 125,
    height: 22
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M711.101 89.6398V110.012H835.801V89.6398H711.101ZM732.901 106.932L732.301 101.168L737.201 100.671L737.801 106.435L732.901 106.932ZM784.201 101.565L783.601 95.8013L788.501 95.3044L789.101 101.068L784.201 101.565Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20994_306980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.867 95.3376L833.467 91.5823L713.144 104.244L713.545 108L833.867 95.3376Z",
    fill: "#0730C3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20994_306980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 713,
    y: 109,
    width: 125,
    height: 21
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M713.2 109.416V129.789H837.9V109.416H713.2ZM760.6 124.025L760 118.261L764.9 117.764L765.5 123.528L760.6 124.025ZM811.9 118.658L811.3 112.894L816.2 112.398L816.8 118.161L811.9 118.658Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20994_306980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M835.924 115.155L835.523 111.399L715.201 124.062L715.601 127.817L835.924 115.155Z",
    fill: "#0730C3"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822.7 116.969L778.8 78.7081L788.1 66.882C788.5 66.3851 789.1 66.2857 789.5 66.5839C791.4 68.1739 794.5 67.4783 796.5 65.0932L804.2 54.4597L818.9 34.9814C819.2 34.5839 819.2 34.1864 818.9 33.9876L817.9 33.292C817.6 33.0932 817.2 33.292 816.9 33.6895L803.7 51.1802L800.7 48.7951L814.9 31.7019C815.1 31.4038 815.1 31.0062 814.8 30.7081L814.1 30.1118C813.8 29.9131 813.4 29.9131 813.1 30.2112L799 47.4038L796.8 45.6149L811 28.5218C811.2 28.2236 811.2 27.8261 810.9 27.528L810.2 26.9317C809.9 26.733 809.5 26.733 809.2 27.0311L795 44.1243L792.4 42.0373L807.1 25.7392C807.4 25.441 807.5 24.9441 807.3 24.7454L806.5 23.851C806.3 23.6522 805.8 23.7516 805.5 24.0497L789.6 41.6398C789.4 41.7392 789.2 41.9379 789.1 42.1367L780.2 51.8758C778.3 54.2609 778.2 57.441 780.1 58.9317C780.5 59.2298 780.5 59.9255 780.1 60.4224L769 73.3417L736.6 45.118C732 41.1429 725 41.5404 721 46.1118C720.7 46.5094 720.7 47.0062 721.1 47.3044L761.3 82.2858L743.7 102.36C740.1 106.634 739.5 112 742.2 114.286C744.9 116.571 750.1 114.882 753.7 110.509L768.5 91.8261L811.7 129.491C813.1 130.783 815.4 130.584 816.6 129.193L822.9 122.037C824.3 120.447 824.1 118.261 822.7 116.969Z",
    fill: "#131A46"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M824.501 35.5777L808.601 56.7454L800.201 68.3727C798.101 70.9566 794.701 71.6522 792.601 69.9628C792.201 69.5653 791.501 69.764 791.101 70.2609L777.301 87.6522L773.101 93.0187L753.701 117.565C749.801 122.236 744.201 124.124 741.201 121.64C738.201 119.155 738.901 113.391 742.801 108.721L763.301 85.0684L767.201 80.497L782.301 63.0063C782.801 62.5094 782.801 61.8137 782.301 61.4162C780.201 59.7268 780.301 56.2485 782.401 53.6647L792.101 43.1305C792.301 42.9317 792.501 42.733 792.701 42.6336L810.001 23.7516C810.301 23.3541 810.801 23.2547 811.001 23.5529L811.901 24.4473C812.101 24.646 812.101 25.1429 811.701 25.5404L795.701 43.2299L798.501 45.5156L813.901 26.8324C814.201 26.5342 814.601 26.4349 814.901 26.733L815.701 27.4286C816.001 27.7268 816.101 28.1243 815.801 28.5218L800.401 47.205L802.801 49.1926L818.201 30.5094C818.501 30.2113 818.901 30.1119 819.301 30.41L820.101 31.1057C820.401 31.4038 820.501 31.8013 820.201 32.1988L804.801 50.6833L808.001 53.2672L822.401 34.1864C822.701 33.7889 823.201 33.5901 823.501 33.7889L824.601 34.4845C824.901 34.7827 824.901 35.1802 824.501 35.5777Z",
    fill: "#FFE600"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M777.301 87.7516L773.101 93.1181L763.301 85.1677L767.201 80.5963L777.301 87.7516Z",
    fill: "#293D91"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M768 79.1056L767.5 79.7019C767 80.1988 766.2 80.2982 765.7 79.8013L712.6 33.4907C712.2 33.1926 712.2 32.5963 712.5 32.1988C716.9 27.2299 724.5 26.733 729.5 31.1056L767 63.8013C771.5 67.7764 771.9 74.6336 768 79.1056Z",
    fill: "#E6E8F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M823.5 114.783L816.6 122.634C815.2 124.224 812.8 124.323 811.2 123.031L762.1 80.2982C760.5 78.9068 760.4 76.5218 761.7 74.9317L768.6 67.0808C770 65.4907 772.4 65.3913 774 66.6832L823.1 109.416C824.7 110.807 824.9 113.193 823.5 114.783Z",
    className: "illustration_primary_default"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M774.8 82.087C776.402 82.087 777.7 80.7967 777.7 79.205C777.7 77.6133 776.402 76.323 774.8 76.323C773.199 76.323 771.9 77.6133 771.9 79.205C771.9 80.7967 773.199 82.087 774.8 82.087Z",
    fill: "#E6E8F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M787.8 93.4162C789.402 93.4162 790.7 92.1259 790.7 90.5342C790.7 88.9425 789.402 87.6522 787.8 87.6522C786.199 87.6522 784.9 88.9425 784.9 90.5342C784.9 92.1259 786.199 93.4162 787.8 93.4162Z",
    fill: "#E6E8F5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M800.8 104.745C802.402 104.745 803.7 103.455 803.7 101.863C803.7 100.272 802.402 98.9814 800.8 98.9814C799.199 98.9814 797.9 100.272 797.9 101.863C797.9 103.455 799.199 104.745 800.8 104.745Z",
    fill: "#E6E8F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20994_306980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetOrderHistory);
export default __webpack_public_path__ + "static/media/BackgroundWidgetOrderHistory.66e119ba.svg";
export { ForwardRef as ReactComponent };